import { useState } from 'react'

import { StyledHeaderBanner, BannerSkeleton, HeaderBannerContainer, HeaderBannerTextOverlay } from './HeaderBanner.styled'
import { BannerSubtitleText, BannerTitleText } from '../../styles/Typography.styled'
import { Grid } from '@mui/material'
import { BannerPosition } from '../../../features/Configuration/GeneralConfiguration/types/types'

interface HeaderBannerProps {
  src: string
  title?: string
  subtitle?: string
  objectPosition?: BannerPosition
}

export const HeaderBanner = ({ src, title, subtitle, objectPosition = 'center' }: HeaderBannerProps) => {
  const [isLoading, setIsLoading] = useState(true)
  const hasOverlayText = !isLoading && Boolean(title || subtitle)

  return (
    <HeaderBannerContainer>
      {isLoading && <BannerSkeleton />}
      <StyledHeaderBanner
        src={src}
        alt="Banner"
        onLoad={() => setIsLoading(false)}
        $objectPosition={objectPosition}
        style={{ display: isLoading ? 'none' : 'block' }}
      />
      {hasOverlayText && (
        <HeaderBannerTextOverlay>
          {title && (
            <Grid size={{ mobile: 12 }}>
              <BannerTitleText textColor="white">{title}</BannerTitleText>
            </Grid>
          )}
          {subtitle && (
            <Grid size={{ mobile: 12 }}>
              <BannerSubtitleText textColor="white">{subtitle}</BannerSubtitleText>
            </Grid>
          )}
        </HeaderBannerTextOverlay>
      )}
    </HeaderBannerContainer>
  )
}

export default HeaderBanner
